import React from 'react';
import omit from 'lodash/omit';
import { faSave } from '@fortawesome/free-regular-svg-icons/faSave';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import FormHttpBtn from './FormHttpBtn.jsx';

const FormHttpSaveBtn = (props) => {
  const {
    res,
    children,
    highlight = false,
    onlyValid = false,
  } = props;
  const { dirty, isValid } = useFormikContext();
  const { t } = useTranslation();

  return (
    <FormHttpBtn
      type="submit"
      className={highlight && dirty ? 'btn-danger' : 'btn-primary'}
      icon={faSave}
      disabled={!dirty || (onlyValid && !isValid)}
      {...omit(props, ['children', 'highlight', 'onlyValid'])}
    >
      {children
        || t(`Save${!dirty && res.status === 'success' ? 'd' : ''}`)
      }
    </FormHttpBtn>
  );
};

export default FormHttpSaveBtn;
